module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1053-111799b6b4087c8cf8f88eac719877c0.png";